import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import type { NavigateOptions } from 'react-router-dom';

export function useNavigateWithUTMs() {
  const navigate = useNavigate();
  const { search } = useLocation();

  const appendUTMs = useCallback((to: string): string => {
    if (!search) return to;
    const currentParams = new URLSearchParams(search);

    const [path, existingSearch] = to.split('?');
    const destParams = new URLSearchParams(existingSearch);
    currentParams.forEach((value, key) => {
      if (!destParams.has(key)) destParams.set(key, value);
    });
    return `${path}?${destParams.toString()}`;
  }, [search]);

  const navigateWithUTMs = useCallback((to: string | number, options?: NavigateOptions) => {
    // number is a history delta (e.g. navigate(-1) to go back), not a URL — skip param appending
    if (typeof to === 'number') {
      navigate(to);
      return;
    }
    navigate(appendUTMs(to), options);
  }, [navigate, appendUTMs]);

  return { navigate: navigateWithUTMs, appendUTMs };
}
